// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSessionDocAssemble,
  getAnswerDocAssemble,
  getGeneratedPdf,
  checkSOA,
  getSoaDoc,
  setLateSoa,
  CalculateFees,
  ProceedToPay,
  CheckMainSubmissionDone,
  GetLatestSoa,
} from "@api";

export const getSession = createAsyncThunk(
  "scheduleofassets/getSession",
  async (args) => {
    const response = await getSessionDocAssemble({ interviewName: args });
    return response.data;
  }
);

export const getAnswer = createAsyncThunk(
  "scheduleofassets/getAnswer",
  async (args) => {
    const response = await getAnswerDocAssemble({ session: args });
    return response.data;
  }
);

export const getGeneratedPdfFile = createAsyncThunk(
  "scheduleofassets/getGeneratedPdf",
  async (args) => {
    const response = await getGeneratedPdf({ fileId: args });
    return response.data;
  }
);

export const checkSOAExist = createAsyncThunk(
  "scheduleofassets/checkSOA",
  async (args) => {
    const response = await checkSOA({ args });
    return response.data;
  }
);

export const getSoaDocList = createAsyncThunk(
  "scheduleofassets/getSoaDoc",
  async (args) => {
    const response = await getSoaDoc({ args });
    return response.data;
  }
);

export const setLaterSoa = createAsyncThunk(
  "scheduleofassets/setLateSoa",
  async (args) => {
    const response = await setLateSoa({ args });
    return response.data;
  }
);

export const calculateFeesSoa = createAsyncThunk(
  "payment/calculate_fees_",
  async (args) => {
    const response = await CalculateFees(args);
    return response.data;
  }
);

export const proceedToPaySoa = createAsyncThunk(
  "payment/proceed_to_pay",
  async (args) => {
    const response = await ProceedToPay(args);
    return response.data;
  }
);

export const checkMainSubmissionDoneSoa = createAsyncThunk(
  "payment/check_mainsubmission_done_soa",
  async (args) => {
    const response = await CheckMainSubmissionDone(args);
    return response.data;
  }
);

export const getLatestSoa = createAsyncThunk(
  "payment/get_latest_soa_soa",
  async (args) => {
    const response = await GetLatestSoa(args);
    return response.data;
  }
);

export const scheduleOfAssetsSlice = createSlice({
  name: "scheduleofassets",
  initialState: {
    session: "",
    totalPayable: (0.0).toFixed(2),
    submissionGroupid: "",
    isSoaExist: false,
    isSoaSubmitted: false,
    isSoaProcessed: false,
    isGrantOfProbateExists: false,
    isLateSoa: false,
    showPaymentModal: false,
    isChecked: false,
    isConfirm: false,
    newlyGeneratedSoaFileId: "",
    isGenerated: false,
    showDocAssemble: false,
    isSoaAccepted: false,
    isMainSubmissionPaid: false, // Check if MainSubmission was performed
    latestSoaStatus: "",
    isPaymentProcessing: false,
  },
  reducers: {
    updateShowDocAssemble(state, action) {
      state.showDocAssemble = action.payload;
    },
    updateShowPaymentModal(state, action) {
      state.showPaymentModal = action.payload;
    },
    updateIsChecked(state, action) {
      state.isChecked = action.payload;
    },
    updateIsConfirm(state, action) {
      state.isConfirm = action.payload;
    },
    updateIsGenerated(state, action) {
      state.isGenerated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSession.fulfilled, (state, action) => {
        state.session = action.payload;
      })
      .addCase(calculateFeesSoa.fulfilled, (state, action) => {
        state.totalPayable = action.payload.TotalPayable.toFixed(2);
        state.submissionGroupid = action.payload.SubmissionGroupId;
        state.showPaymentModal = true;
      })
      .addCase(checkSOAExist.fulfilled, (state, action) => {
        state.isSoaExist = action.payload.isSoaExist;
        state.isSoaSubmitted = action.payload.isSoaSubmitted;
        state.isSoaProcessed = action.payload.isSoaProcessed;
        state.isLateSoa = action.payload.isLateSoa;
        state.isSoaAccepted = action.payload.isSoaAccepted;
        state.isGrantOfProbateExists = action.payload.isGrantOfProbateExists;

        if (state.isMainSubmissionPaid)
          state.showDocAssemble = !state.isSoaExist;
        else state.showDocAssemble = !state.isSoaSubmitted;
      })
      .addCase(checkMainSubmissionDoneSoa.fulfilled, (state, action) => {
        /***
         * isPaid = True -> PostSubmission
         * isPaid = False -> PreSubmission
         */
        state.isMainSubmissionPaid = action.payload.isPaid;
        state.isPaymentProcessing = action.payload.isPaymentProcessing;
      })
      .addCase(getAnswer.fulfilled, (state, action) => {
        if (typeof action.payload.item3 === "string") {
          state.newlyGeneratedSoaFileId = action.payload.item3;
          state.isGenerated = true;
          // state.showDocAssemble = state.isSoaSubmitted ? false : true;
        }
      })
      .addCase(getLatestSoa.fulfilled, (state, action) => {
        /**
         * New - Next btn disabled, only enabled when checkbox is ticked in Presubmission
         * Pending - Always disabled Next btn
         * Accepted/Rejected - Always enabled Next btn
         */
        if (action.payload) state.latestSoaStatus = action.payload.status;
        else state.latestSoaStatus = "";
      });
  },
});

export const scheduleOfAssetsActions = scheduleOfAssetsSlice.actions;
export default scheduleOfAssetsSlice.reducer;
